const getters = {
    role: (state) => state.role,
    loading: state => state.loading
};

export default getters;